import { useContext } from "react";
import ThemeContext from "../context/ThemeProviderContext";

const useThemeHook = (): "light" | "dark" => {
  const { theme, toggleTheme } = useContext(ThemeContext);
  return theme as any;
};
export default useThemeHook;
